"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NFTExchangeResources = void 0;
const auctions_1 = require("./auctions");
const bids_1 = require("./bids");
const configurations_1 = require("./configurations");
const trades_1 = require("./trades");
exports.NFTExchangeResources = {
    configurations: configurations_1.Configurations,
    auctions: auctions_1.Auctions,
    bids: bids_1.Bids,
    trades: trades_1.Trades,
};
//# sourceMappingURL=index.js.map